import contentfulGql from 'js/lib/contentfulGql';

import { promoTemplateCollectionsFragment } from 'bundles/promo-template/queries/PromoTemplateCollections';

const EmbeddedPageContentQuery = contentfulGql`#graphql
  ${promoTemplateCollectionsFragment}
  query EmbeddedPageContent($slug: String!, $domain: String!, $preview: Boolean, $locale: String!) {
    promoTemplateEmbeddedPageContentCollection(where: { slug: $slug, domain_contains_some: [$domain] }, limit: 1, preview: $preview, locale: $locale) {
      items {
        slug
        modulesCollection(limit: 16) {
          items {
            ...PromoTemplateCollections
          }
        }
      }
    }
  }
`;

export default EmbeddedPageContentQuery;
